import { ParsedCartItemGroup } from 'ui/types/cartTypes';
import { PlanTypes } from 'ui/utils/constants/maverick';
import {
  getIsFamilyFromAttributes,
  getIsTwoYearFromAttributes,
  getIsTypeFromAttributes,
} from './attributeHelper';

export const getIsSomeMembershipInCart = (
  cartItemGroups: ParsedCartItemGroup[],
  membershipSkus: string[],
): boolean => {
  return cartItemGroups.some((group) =>
    group.cartItems.some((item) => membershipSkus.includes(item.sku)),
  );
};

export const getIsMembershipTypeInCart = (
  cartItemGroups: ParsedCartItemGroup[],
  planType: PlanTypes,
): boolean => {
  return cartItemGroups.some((group) =>
    group.cartItems.some((cartItem) => {
      if (cartItem.attributes) {
        if (planType === PlanTypes.FAMILY) {
          return getIsFamilyFromAttributes(cartItem.attributes);
        } else if (planType === PlanTypes.TWO_YEAR) {
          // replace this with getIsTypeFromAttributes once BE response returns "twoYear" instead of "annual"
          return getIsTwoYearFromAttributes(cartItem.attributes);
        } else return getIsTypeFromAttributes(cartItem.attributes, planType);
      }
      return false;
    }),
  );
};
